import React from 'react';
import { useTranslation } from 'react-i18next';
import { Edit } from "../../../../interfaces/reservation.interface";
import { Tooltip } from '@mui/material';
import { formatAmount, formatDollarAmount } from "../../../../utils/methods";

interface StatsProps {
  formData: Edit;
  external: boolean;
  onHostPayoutClick?: () => void;
  onOwnerRevenueClick?: () => void;
  onCoHostCommissionClick?: () => void;
  onClientRevenueClick?: () => void;
}

const Stats: React.FC<StatsProps> = ({ formData, external, onHostPayoutClick, onOwnerRevenueClick, onCoHostCommissionClick, onClientRevenueClick }) => {
  const { t } = useTranslation();

  return (
    <div className="col-xl-3 col-md-4 col-12 sticky-top" style={{ top: external ? 0 : 80 }}>
      <div className="card mb-4 bg-label-success">
        <div className="card-header pb-2">
          <h6 className="mb-0">{t("reservations.edit.pageTexts.form.stats.commissionHeading")}</h6>
        </div>
        <div className="card-body row">
          <div className="col-5">
            <h5 className="mb-0">{formData.commission} %</h5>
            <p className="mb-0 text-gray">{t("reservations.edit.pageTexts.form.stats.commission")}</p>
          </div>
          <div className="col-2">
            <div className="divider divider-vertical">
              <div className="bg-transparent z-2">
                <span className="bg-label-success pl-2">
                  <i className="ri-percent-line ri-24px"> </i>
                </span>
              </div>
            </div>
          </div>
          <div className="col-5">
            <h5 className="mb-0">{formData.platformCommission ? `${Number(formData.platformCommission).toFixed(2)} %` : '-'}</h5>
            <p className="mb-0 text-gray">{t("reservations.edit.pageTexts.form.stats.platformCommission")}</p>
          </div>
        </div>
      </div>

      <div className="card card-border-shadow-danger mb-4 cursor-pointer" onClick={onHostPayoutClick}>
        <div className="card-body">
          <div className="d-flex align-items-center flex-nowrap">
            <div className="avatar me-4">
              <div className="avatar-initial bg-label-danger rounded-3">
                <i className="ri-bank-card-line ri-24px"> </i>
              </div>
            </div>
            <div className="card-info">
              <div className="d-flex align-items-center">
                <h5 className="mb-0 me-2">{formData.hostPayout ? formatDollarAmount(formatAmount(formData.hostPayout)) : '-'}</h5>
              </div>
              <p className="mb-0">{t("reservations.edit.pageTexts.form.stats.hostPayment")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="card card-border-shadow-primary mb-4 cursor-pointer" onClick={onOwnerRevenueClick}>
        <div className="card-body">
          <div className="d-flex align-items-center flex-nowrap">
            <div className="avatar me-4">
              <div className="avatar-initial bg-label-primary rounded-3">
                <i className="ri-money-dollar-circle-line ri-24px"></i>
              </div>
            </div>
            <div className="card-info">
              <div className="d-flex align-items-center">
                <h5 className="mb-0 me-2">{formData.ownerRevenue ? formatDollarAmount(formatAmount(formData.ownerRevenue)) : '-'}</h5>
              </div>
              <p className="mb-0">{t("reservations.edit.pageTexts.form.stats.ownerRevenue")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="card card-border-shadow-info mb-4 cursor-pointer" onClick={onCoHostCommissionClick}>
        <div className="card-body">
          <div className="d-flex align-items-center flex-nowrap">
            <div className="avatar me-4">
              <div className="avatar-initial bg-label-info rounded-3">
                <i className="ri-hand-coin-line ri-24px"> </i>
              </div>
            </div>
            <div className="card-info">
              <div className="d-flex align-items-center">
                <h5 className="mb-0 me-2">{formData.coHostCommission ? formatDollarAmount(formatAmount(formData.coHostCommission)) : '-'}</h5>
              </div>
              <p className="mb-0">{t("reservations.edit.pageTexts.form.stats.coHostCommission")}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="card card-border-shadow-warning mb-4 cursor-pointer" onClick={onClientRevenueClick}>
        <div className="card-body">
          <div className="d-flex align-items-center flex-nowrap">
            <div className="avatar me-4">
              <div className="avatar-initial bg-label-warning rounded-3">
                <i className="ri-wallet-3-line ri-24px"> </i>
              </div>
            </div>
            <div className="card-info">
              <div className="d-flex align-items-center">
                <h5 className="mb-0 me-2">{formData.clientRevenue ? formatDollarAmount(formatAmount(formData.clientRevenue)) : '-'}</h5>
              </div>
              <p className="mb-0">{t("reservations.edit.pageTexts.form.stats.clientRevenue")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stats;